export default {
  "_En": "英語",
  "_Jp": "日本語",

  //header
  header_no_notification: '通知なし',
  header_notification: '通知',
  header_profile: 'プロフィール',
  header_companies: '会社',
  header_recruits: '求人',
  header_my_company: '会社情報',
  header_engineers: 'エンジニア',
  header_logout: 'ログアウト',


  //register
  r_title: 'プロフィール入力',
  r_basic_info: 'まずはあなたの基本情報を教えてください。',
  r_sub_basic_info: '以下の項目を入力しておくと、スカウトされやすくなります。',
  r_firstname: '名',
  r_firstname_phonetic: '名 (ふりがな)',
  r_select_firstname: '名を入力',
  r_lastname: '姓',
  r_lastname_phonetic: '姓 (ふりがな)',
  r_select_lastname: '姓を入力',
  r_nickname: 'ニックネーム',
  r_initials: 'イニシャル',
  r_select_nickname: 'ニックネームを入力',
  r_email: 'メールアドレス',
  r_password: 'パスワード',
  r_c_password: 'パスワードの確認',
  r_dob: '生年月日',
  r_dob_year: '年',
  r_dob_month: '月',
  r_dob_day: '日',
  r_gender: '性別',
  r_g_male: '男性',
  r_g_female: '女性',
  r_location: '所在地',
  unify_test: '記入してください',
  unify_test_pos: 'その時の役割を記入してください',
  unify_test_what_resp: '詳細を記入してください',
  r_select: '選択してください',
  r_select_exp_corp: '所属していた企業の種類を選択してください',
  r_experience: 'エンジニア経験年数',
  r_how_to_work: '希望の働き方',
  r_button: '登録',
  r_registration_alert: "に同意して、新規登録をしてください。",
  r_term : '利用規約',
  r_poicy: '個人情報の取り扱い',
  r_END : 'および',
  r_back_to_login: '既にアカウントを持っていますか？',
  r_input_password_validation: 'パスワードは半角英数字6文字以上で入力してください',
  r_password_validation: 'パスワードは必須項目です',
  r_c_input_password_validation: 'パスワードが一致していません',
  r_c_password_validation: 'パスワードの確認は必須項目です',
  r_current_password_validation: '現在のパスワードが必要です',
  r_c_nickname_validation: 'ニックネームは20文字以内で入力してください',
  r_firstname_validation: '名は必須項目です',
  r_lastname_validation: '姓は必須項目です',
  r_nickname_validation: 'ニックネームは必須項目です',
  r_c_email_validation: '正しいメールアドレスの形式で入力してください',
  r_email_validation: '正しいメールアドレスの形式で入力してください',
  r_year_validation: '年は必須項目です',
  r_month_validation: '月は必須項目です',
  r_day_validation: '日は必須項目です',
  r_expertise_validation: '専門知識は必須項目です',
  r_job_seeking_validation: '求職状況は必須項目です',
  r_recommended_browser: '※GoogleChrome最新版での登録をお勧めしております。',

  //login
  Login_title: 'ログイン',
  l_email: 'メールアドレス',
  l_password: 'パスワード',
  fdButtonTitle: 'Facebook',
  loginButtonTitle: 'メールアドレスでログイン',
  forgotTitle: 'パスワードを忘れた場合',
  nextTitle: '初めての方はこちら（エンジニア様）',
  inquiryTitle: '初めての方はこちら（企業様）',
  passwordPlaceholder: '半角英数字6文字以上',
  OR: 'または',
  sendVerificationLink: '確認リンクを送信する',
  resendVerificationLink: '確認メールを再送信しますか？',

  //footer
  f_side1_title: '利用規約',
  f_side2_title: '個人情報保護方針',
  f_side3_title: 'お問合せ',
  f_side4_title: '会社概要',
  f_copyright: 'Copyright© E3. All Rights Reserved.',

  //error messages
  l_email_incorrect: '正しいメールアドレスの形式で入力してください。',
  l_password_incorrect: 'パスワードは半角英数字6文字以上で入力してください。',

  //company-list
  c_title: '企業を探しましょう',
  c_desc: '色々な観点から自分に合った企業を見つけ、お気に入りやメッセージを送ることで、アプローチすることができます。',
  c_title_recruit: '求人を探しましょう',
  c_desc_recruit: '現在募集中の求人の中から気になるものを探し、お気に入りやメッセージを送ることで、アプローチすることができます。',
  c_search_result: '検索結果一覧',
  c_search_select: '表示順を選択',
  c_search_keyword: 'キーワードを入力してください',
  c_search_example: '例：PHP、Web、アプリなど',
  c_shorting_check1: '募集終了を隠す',
  c_shorting_check2: '新着のみ表示',
  c_button: ' 気になる',
  c_andmore: 'And more',
  c_category: 'カテゴリー',
  comments_manager : '運営からのコメント',

  //company-profile
  cp_title: 'マイページ',
  cp_desc: '募集要項や会社情報を登録することで、よりエンジニアにアピールすることができます。',
  cp_page: '企業一覧',
  cp_basic_info: '基本情報',
  cp_name: '企業名',
  cp_location: '所在地',
  cp_establishment: '設立年',
  cp_representative: '代表者',
  cp_noe: '社員数',
  cp_company_desc: '会社説明',
  cp_service_desc: 'サービス説明',
  cp_button: 'プロフィール編集・更新',

  //company-profile edit
  cp_edit_date: '設立年',
  cp_edit_update: '更新',
  cp_dob_year: '年',
  cp_dob_month: '月',
  cp_dob_day: '日',
  cp_person: '担当者',
  cp_e_url: '会社URL',
  cp_industry: '業界',
  cp_job_cat: '職種',
  cp_engineer_experience: 'エンジニアの経験',
  cp_idea: 'アイディア',
  cp_vision: 'ビジョン',
  cp_image_crop: '切り取り',
  cp_image_rotate: '回転する',
  cp_done: "完了",
  cp_technique_stack: 'テクニカルスタック',
  role_to_handle: '担当役割',
  select_role_to_handle: '担当役割を入力してください',
  update_password: "パスワードの更新",
  current_password: "現在のパスワード",
  change_password: "パスワードを変更する",
  error_changing_password: "あなたの現在のパスワードは、あなたが入力したパスワードと一致しません。もう一度お試しください",
  password_updated: "パスワードは正常に変更されました",

  //company-profile sidebar
  company_user_page: 'トップページ',
  company_page: '会社プロフィール',
  job_offer: '求人',
  all_engineers: '全てのエンジニア',
  job_list: '求人一覧',
  recruit_list: '求人一覧',
  recruiting_new_job: '新しく求人を募',
  job_information_preview: '求人情報プレビュー',
  talent: '人材',
  personnel_list: '人材一覧',
  people_search: '人材を探す',
  human_research_profile: '人材プロフィール',
  instrested_engineers_list: '興味を持たれたエンジニア',
  favorited_engineers: 'お気に入りしたエンジニア',
  action: 'アクション',
  //action_list: 'メッセージリスト',
  option: 'オプション',
  option_list: 'オプション一覧',
  option_in_use: '利用中オプション',
  other: 'その他',
  message: 'メッセージ',
  chat: 'チャット',
  change_contract_plan: '契約プラン変更',
  company: '会社',
  company_update: '会社情報更新',
  cp_other_sidebar: 'プロフィール編集',

  //usageguide
  usage_guide: '利用ガイド',
  usage_guide_title1: 'オプションサービスとは、エンジニアが仕事に専念し、成長するために、自由に選んでご利用いただける各種サービスのことです。',
  usage_guide_title2: '詳しくは下記をご参照ください。',
  usage_guide_title3: 'オプション説明エンジニア向け（PDF）',

  //company-list sidebar
  recruitment_situation: '採用状況',
  available: '絶賛募集中',
  all: 'すべて',

  company_established: "会社の設立年数",
  one_year: "1年未満",
  three_year: "3年未満",
  five_year: "5年未満",
  ten_year: "10年未満",
  ten__year: "10年以上",

  business_type: '事業形態',
  btob: 'BtoB',
  btoc: 'BtoC',
  ctoc: 'CtoC',
  Sler: '受託/SI',

  stage: 'ステージ',
  listed: '上場',
  non_listed: '非上場',
  startup: 'スタートアップ',
  rounded: '資金調達済み',

  benefit: 'アピールポイント',
  remote_work: 'リモートのみ',
  flextime: 'フレックス勤務',
  favorite_engineer: '著名なエンジニア/コミッター所属',
  dress_free: '服装自由',
  sidework: '副業可能',
  stock_option: 'ストックオプションあり',
  mac_windows_linux: '作業用PC選択可能',
  free_drink: 'フリードリンク',

  ratio_of_engineer: 'エンジニア比率',
  ten_per: '10％未満',
  ten_btw_thirty: '10％以上30％未満',
  thirty_btw_fifty: '30％以上50％未満',
  fifty_per: '50％以上',

  recruitment_tension: "募集テンション",
  asap: 'なるべく早く採用したい',
  good_person: '良い人であれば採用したい',
  disabled: '募集停止',

  job_type: '募集就業形態',
  fulltime: '正社員',
  contractor: '契約社員',
  parttime: 'アルバイト・パート',
  freelancer: '請負・業務委託',

  contract: 'ワークスタイル',
  only_full_time: 'フルタイムのみ',
  hourly: '時短可',
  days: '日数限定可',
  work_office: '常駐のみ',
  sometime_remote_work: '一部リモート可',

  company_hire_engineer: '募集背景',
  growing_business: '事業拡大',
  luck_of_member: '欠員補充',
  current_position: '現担当者異動',


  //company recruit add
  cr_title: '求人作成',
  cr_update: '求人更新',
  cr_desc: '人材募集要項',
  cr_sub: '件名',
  cr_content: '業務内容',
  cr_posting: '記事投稿URL',
  cr_work_location: '勤務地',
  cr_button: '作成',
  cr_supplement_fulltime_parttime: '募集就業形態補足',
  cr_supplement_contract: 'ワークスタイル補足',
  cr_bebefit_engineer: '得られるメリット',
  cr_recruit_role: '任せてもらえる範囲・裁量',
  cr_process_project: 'PJ・開発の進め方',
  cr_current_structure: '現在の体制',
  cr_skill_keyword: 'スキルキーワード',
  required_technique_skill: '求める技術・スキル',
  better_technique_skill_if_there_is: '望ましい技術・スキル',
  required_personality: "求める人材",
  any_request: 'その他要望',

  //company detail
  cd_desc1: '会社について',
  cd_desc2: '理念・ビジョン',
  cd_recruit: '募集中の求人情報',
  cd_about: '会社情報',
  cd_category: 'カテゴリー',

  // job list
  job_title: '求人一覧',
  job_button: '新しく求人を作る',

  //recruit detail
  recruit_copy: 'コピー作成',
  recruit_title: 'コラボレーティブプラットフォーム「E3」の立ち上げメンバー募集！',
  recruit_freelance_type : 'freelance typeは必須項目です',
  recruit_contract_type : 'contract typeは必須項目です',
  recruit_sort_1 : '登録が新しい順',
  recruit_sort_2 : '最終更新日が新しい順',

  //engineer profile
  ep_title: 'マイページ',
  ep_desc: 'ご自身のスキルや経歴を登録することで、より企業にアピールすることができます',
  ep_page: 'トップページ',
  ep_basic_info: 'スキル・キャリアサマリー',
  ep_name: 'お名前',
  ep_age: '年齢',
  ep_id: 'ID',
  ep_bday: '生年月日',
  ep_sex: '性別',
  ep_location: '所在地',
  ep_howToWorkNow: '今の働き方',
  ep_howToWOrk: '希望の働き方',
  ep_decs_emp_con: '希望の就業条件',
  ep_desc_emp_from: '希望の就業形態',
  ep_current_position: '現在の契約形態',
  ep_current_type_of_contract: '現在のワークスタイル',
  ep_required_position: '希望の契約形態',
  ep_requried_type_of_contract: '希望のワークスタイル',
  ep_national: '出身国',
  ep_languages: '語学',
  ep_required_work_area_to_be: '希望の仕事分野',
  expertise: '専門分野',
  engineer_years: '所属したことのある企業種類',
  ep_job_seeking: '求職状況',
  ep_engineer_notification: 'エンジニアお知らせ設定',
  ep_desired: '希望金額',
  ep_desired_error: 'be entered 0 or more',
  ep_currency_unit : '円以上',
  ep_policy: '仕事に対するこだわり',
  e_profile: 'プロフィール',
  e_score: 'スコア',
  ep_button: 'プロフィール編集・更新',
  ep_dob_year: '年',
  ep_dob_month: '月',
  ep_dob_day: '日',
  ep_email: 'メールアドレス',
  ep_change_email: 'メールアドレスを変更する',
  ep_male: '男性',
  ep_female: '女性',
  ep_firstname: '名',
  ep_select_firstname: '名を入力',
  ep_lastname: '姓',
  ep_select_lastname: '姓を入力',
  ep_experience: 'エンジニア経験年数',
  ep_select_policy: '仕事に対するこだわりを入力',
  ep_next: '次へ',
  last_login_time: '最終ログイン時間',

  ep_interview_completion_text: '管理者と面談することであなたの情報が公開されます。',
  ep_interview_completion_text2: '面談の予約を行いたい場合は、お問合せ画面よりご連絡ください。',
  ep_interview_completion_button: 'お問合せ画面',

  ep_past_job_details : '過去の仕事内容',
  ep_past_job_details_error : '少なくとも1セット作成する',
  ep_past_job_details_error2 : 'すべての項目を入力してください',
  ep_position_overview: '役割',
  ep_started_at: '開始年月',
  ep_ended_at: '終了年月',
  ep_date_validation : '開始日は終了日より大きくすることはできません',
  ep_your_responsibilities: '役割の詳細',
  ep_email_verify_text: 'まだメールアドレスが認証されていません。再度認証メールを送信しますか？',
  ep_email_link: '再送信する',

  ep_initials_custom_validation: '英字 ピリオド 英字 で入力してください。例：L.F',

  e_resumes : 'レジュメ',

  //engineer-profile sidebar
  find_job: '仕事を探す',
  scout: 'スカウト',
  unanswered: '未返信',
  replay: '返信済',
  company_list: '求人一覧',
  all_companies: '企業で探す',
  all_recruits: '求人で探す',
  companies_interested: '興味を持たれた企業',
  favorite_company: 'お気に入りした企業',
  favorite_recruit: 'お気に入りした求人',
  message_list: 'メッセージリスト',
  engineer_list: 'エンジニア一覧',
  engineer_profile: 'エンジニアプロファイルの詳細',
  asked_price_person_who_was: 'イイネ！された人',
  resume: 'レジュメ',
  resume_UP: 'レジュメアップロード',
  publishing_settings: '公開設定',
  page_item: '件',
  ep_other_sidebar: 'プロフィール編集',

  //engineer list
  el_title: "エンジニアを探しましょう",
  el_desc: '色々な観点から自社に合った人材を見つけ、スカウトすることができます。',
  el_select: '表示順を選択',
  el_new_user: '登録が新しい順',
  el_old_user: '登録が古い順',
  el_higher_total_score: 'スコアの合計が高い順',
  el_higher_technology_score: 'テクニカルスコアが高い順',
  el_higher_management_score: 'マネジメント/ビジネススコアが高い順',
  el_button: 'イイネ！送信済み',
  el_bread: '請負・業務委託(個人事業主)',
  required_position: "希望の契約形態",
  requried_type_of_contract: "希望のワークスタイル",
  engineers_years: "エンジニア経験年数",
  required_work_Area_to_be: "希望する仕事分野",
  languages: "語学",
  experienced_corporate: "所属したことのある企業種類",


  //chatroom
  chat_back: 'マイページへ戻る',
  back_chat_list: 'メッセージリストへ戻る',
  chat_title: 'コラボレーティブプラットフォーム「E3」の立ち上げメンバー募集！',
  chat_select_file: 'ファイルを選択',
  chat_select: '選択されていません',
  chat_button: 'メッセージを送信',
  chatActiomSelectAll: 'すべて選択',
  download_attachment_file: '添付ファイルをダウンロードする',
  notice_from_the_management:'運営からのお知らせ',
  display_notifications_from_management: '運営からのお知らせを表示する',

  no_result: "検索結果はありません",
  no_more: "no_more",

  Select_file: "ファイルを選択",

  //facebook button
  facebook_button: 'Facebookでログイン',
  facebook_error_email: 'メールが見つかりません',
  facebook_enable: 'Facebookのログインを有効にする',
  facebook_connected: '接続済み',

  //forgot password
  forgotPassword: 'パスワードをお忘れですか',
  forgotPasswordButton: 'パスワードリセットURLを送信',
  resetPassword: 'パスワードの再設定',
  setPasswordButton: 'パスワードを設定する',

  //error messages
  err_unanswered: '未返信のメッセージはありません',
  err_replied: '返信済みのメッセージはありません',
  err_companyFavorited: 'お気に入りに登録した会社はありません',
  err_companyFavoritedByYou: 'あなたに興味を持たれた会社はまだいません',
  err_recruitFavorited: 'お気に入りに登録した求人情報はありません',
  err_favoritedEngineer: '貴社が興味を持ったエンジニアはまだいません',
  err_companyRegisterd: '該当する企業はありません',
  err_engineer: '該当するエンジニアはいません',
  err_group: 'メッセージグループが見つかりません。',
  err_conversation: 'メッセージ履歴はありません。',

  //company user error messages
  err_recruitAvailable: '求人情報はありません。',

  // global error messages
  err_startConversation: 'チャットを始める',
  err_pageNotFoundTitle: 'ページが存在しません',
  err_pageNotFoundBackToHome: 'TOPページに戻る',
  err_pageNotFoundBackToSignin: 'ログインページに戻る',
  err_network: '予期しないエラーが発生しました',
  err_admin: '管理者はログインできません',
  err_skill: '少なくとも1つのスキルを選択してください',
  err_company_favorited: '会社をお気に入りから削除しました',
  err_engineer_favorited: 'エンジニアをお気に入りから削除しました',
  err_recruit_favorited: '求人をお気に入りから削除しました',
  err_skill_not_found: 'スキルが見つかりません',

  //success message
  success_register: "認証メールを送信しました。メールアドレスをご確認ください",
  success_register_completed: "登録が完了しました",
  success_varify_user: "ログインしてください",
  success_forgot_password: "パスワードをリセットしました。再度、ログインしてください",
  success_contact_us1: "お問合せを受け付けました。すぐにご連絡させていただきます。",
  success_contact_us2: "",
  success_edit_profile: "プロフィールの登録が完了しました",
  success_recruit_add: "求人情報の登録が完了しました",
  success_recruit_update: "求人情報の登録が完了しました",
  success_fevorited_list: "お気に入りリストから削除されました",
  success_reset_password: "パスワードをあなたのメールアドレスに送信しました。",
  success_change_mail: "確認リンクがこのメールアドレスに送信されました。",
  success_skill: 'スキル更新成功',
  success_company_favorited: "会社をお気に入りに追加しました",
  success_engineer_favorited: "エンジニアをお気に入りに追加しました",
  success_recruit_favorited: "求人をお気に入りに追加しました",
  success_engineer_notification: "エンジニアお知らせ設定の登録が完了しました",
  success_file_upload: 'ファイルが正常にアップロードされました',

  //contact inqury
  contact_title: 'お問合せ',
  contact_subtitle: '',
  contact_item: 'お問合せ内容',
  contact_button: '問合せする',
  contact_name_palceholder: 'あなたの名前を入力してください',
  contact_company_name: 'あなたの会社名を入力してください',
  contact_name_error: '名前が必要です',
  contact_inquire_contant: 'お問い合わせ内容は必須です',

  //privacy policy
  privacy_title: '個人情報保護方針',
  privacy_subtitle: '合同会社E3（以下、「当社」といいます。）は、優れたITエンジニアを生み出す仕組みづくりやサービスの提供を行っています。その中で取得されるお客様（以下、「利用者」といいます。）の個人情報の取り扱いについての当社の基本方針として、以下のとおり個人情報方針（以下、「本ポリシー」といいます。）を定めます。',

  //terms of service
  terms_title: '利用規約',

  /*Engineer Skill Page*/
  sk_page_title: "ITスキルの実績・経験をスコア化してみましょう。",
  sk_page_sub_title: '以下の質問にお答えください。',
  sk_skill_update: 'スキル更新',
  sk_input_profile_skill_lb: 'スキルを入力してください',
  sk_total_lb: '合計',
  sk_technical_lb: 'テクニカル',
  sk_management_lb: 'マネジメント',
  sk_business_lb: 'ビジネス',
  sk_selectskill_lb: 'スキルを選んでください',
  sk_each_programming_lb: 'それぞれの項目のレベルを選択してください。',
  sk_entrylevel_lb: 'ビギナーレベル',
  sk_intermed_lb: 'ミドルレベル',
  sk_expert_lb: 'エキスパートレベル',
  sk_result_lb: '結果',
  sk_custom_placeholder: '自由に記述してください',
  sk_save_btn_lb: '保存 ',
  sk_sentence1: 'それぞれの項目(スキル)を、最も当てはまるボックスに振り分けてください。',
  sk_sentence2: 'スキルを選択し(複数選択可)、その後当てはまるボックスをクリックすると振り分けられます。',
  sk_sentence3: '当てはまるものがない場合は、選択する必要はありません。',
  sk_asterisk: '※',
  sk_confirm: '保存していない内容は破棄されます。このページを離れますか？',

  about_defination: '定義について',

  definition: '定義',

  description_of_definitions: '定義の説明',
  definition_of_choice: '選択肢の定義',
  no_experience: '経験ない',
  no_experience_desc: '：業務経験がない（独習のみも含む)',
  experienced: '経験ある',
  experienced_desc: '：業務経験がある',
  no_confidence: '自信ない',
  no_confidence_desc: '：指示を受けたり、情報をもらえないと進められない',
  confident: '自信ある',
  confident_desc: '：スケジュールを調整しながら、主体的に完遂できる',
  very_confident: 'とても自信ある',
  very_confident_desc: '：主体的に遂行しつつ、人に教えられる',
  know: '知っている',
  know_desc: '：どのような特性を持ったものであるか知識は持っている',
  implement: '運用できる',
  implement_desc: '：既に運用されているものを巻き取り、滞りなく運用していける',
  set: '設定できる',
  set_desc: '：構築されたものを実運用に合わせて設定し、運用していける',
  build: '構築できる',
  build_desc: '：要件に合わせて0から構築し、運用していける',

  defination_intention: '知りたいこと(意図)の定義',
  occurred: '技術的な問題に遭遇した際の対処方法',
  occurred_desc: '：課題解決力',
  catch_up_technique: '技術のキャッチアップ方法',
  catch_up_technique_desc: '：自己学習能力',
  choose_technique: '技術選定のポイント',
  choose_technique_desc: '：アーキテクト能力',

  definition_of_skill: 'スキルの定義',
  pmo: 'PMO（Project/Program Management Office)',
  pmo_desc: '：組織内における個々のプロジェクトマネジメントの支援を横断的に行う部門や構造システムを指す',
  have_knowledge: '知識ある',
  have_knowledge_desc: '：専門の資格を保有している、又は、上流設計の経験がある',
  pay_attention: '注視している',
  pay_attention_desc: '：日常的にメディアや書籍などで情報収集してい',
  have_know: '知っている',
  have_know_desc: '：知識がある',
  management_experienced: '経験ある',
  management_experienced_desc: '：業務経験がある',
  in: '※ ',
  in_desc1: '情報発信',
  in_desc2: "では、「定期的に投稿している、開催している」と定義する",

  what_i_want: '知りたいこと(意図)の定義',
  member_growing_up: 'メンバーの育成やコーチングについて意識していること',
  member_growing_up_desc: '育成力',
  team_member: 'チーム/メンバーのモチベーションの上げ方',
  team_member_desc: '：プロジェクトを円滑に進める力',
  bussiness_will_taken: '今後どんなビジネスに携わっていきたいか？',
  bussiness_will_taken_desc: '：経験を活かした分野なのか、新しい分野へのチャレンジなのか、今後の方向性',

  trial_period: '無料トライアル期間が終了しました。',
  trial_period_desc: '今後もサービスご利用の場合はお問合せより本契約についてお問合せください。',
  inquiry: '問合せする',
  logout: 'ログアウトする',

  required_filed: 'この項目は必須です',

  //tooltip
  tooltip_en_desc1: '複数のキーワードで検索する際は、AND検索はプラス記号、OR検索は半角スペースを用いてください。',
  tooltip_en_desc2: '例）AND検索：',
  tooltip_en_desc3: 'OR検索：',

  //pop-up
  pop_up_title: '現在の求職状況は',
  pop_up_it_ok: 'に設定されています。最新の情報に更新する場合は「変更する」から更新を行うことができます。',
  pop_up_ok: 'OK',
  pop_up_unselected: '未選択',
  pop_up_change: '変更する',

  //Setting mail
  setting_menu_name : '設定',
  setting_sub_had_name : 'メール受取設定',
  setting_item_text1 : 'あなたがお気に入りされた時にメールを受け取る',
  setting_item_text2 : 'あなたがメッセージを受け取った時にメールを受け取る',

  setting_sub_had_name2 : '実名公開設定',
  setting_item2_text1 : '企業担当者に実名を公開する',

  real_name_setting_message : '実名が公開されるのは、あなたがメッセージを送った企業にのみとなります。',

  publish_real_name: 'メッセージ送信時に実名を公開',

  past_job_period: '期間',
  past_job_details: '詳細',

  communicate_title: 'カジュアルなやり取り設定',
  communicate_sub_heading: 'カジュアルにやり取りをしたい意思を表明する',

  speech_bubble: "カジュアルなやりとりOK！",

  //popover
  popover_desc1: 'トライアルプラン',
  popover_desc2: 'はお試しプランであり、こちらからメッセージを送れるエンジニアの数が3人までとなります。また、エンジニアからメッセージを受け取った場合は数にはカウントされません。',
  popover_desc3: 'スタンダードプラン',
  popover_desc4: 'はエンジニアの人数制限がなく、契約中はサービスを利用し続けることができます。',
  popover_desc5: '詳しくは問合せページよりお問い合わせください。',

  maintenance_title: 'ただいまメンテナンス中です。',
  maintenance_sub_heading1: 'ご不便をおかけして申し訳ありませんが、現在メンテナンスを行っております。',
  maintenance_sub_heading2: '御用がございましたら、',
  maintenance_sub_heading3: 'お問合せ',
  maintenance_sub_heading4: 'からご連絡ください。',

  payment_text : '支払金額',
  payment_employment_form : '募集就業形態',
  payment_time_unit : '時間単位',
  payment_lower_limit : '下限額',
  payment_upper_limit : '上限額',
  payment_upper_limit_validation : '上限は下限より大きくなければなりません',
  yen: '円',

  //resume-up
  resume_title: 'レジュメアップロード',
  resume_desc1: 'このページではレジュメをアップロードできます。',
  resume_desc2: 'アップロードされたレジュメはすべて企業に公開されます。',

  delete_message : 'レコードを削除しました'
};
